/* eslint-disable sort-keys */

/* THE APPS DATA RELATED TO OUR API */

import { logger } from "../helpers"

/* - Holds all configured data used by all endpoint calls - 
 * Available endpoints we can call.
 * The backend URL we are accessing.
 * Important data/parameters accessible to backend calls that will re-use this info for calls.
 * Temporary data used to send in the body of specefic endpoints.
 */
export const api = {
  endpoints: {
    getEndpoint: "/getEndpoint",
    postEndpoint: "/postEndpoint"
  },
  host: process.env.QUIZKIT_URL,
  pubsub: {
    url: process.env.PUBSUB_URL,
  },
  params: {
    headers: null,
    lobbyCode: null,
    playerId: null,
    token: null,
  }
}

/* - Updates API parameter with newvalue, passed through function - */
export const updateApiParams = (thisParam, newValue) => {
  if (typeof newValue === "object") {
    logger.logToConsole(`Setting ${thisParam} api param:`)
    logger.logToConsole(newValue)
  } else {
    logger.logToConsole(`Setting ${thisParam} api param: ${newValue}`)
  }
  api.params[thisParam] = newValue
}

/* - Resets non-constant congiured API data - */
const resetApiConfiguration = () => {
  logger.logToConsole(`Resetting API Configuration`)
  api.params.gameId = null
  api.params.lobbyCode = null
  api.params.playerId = null
  api.payloadData = null
}

export default { api, resetApiConfiguration, updateApiParams }